export const phoneForDb = (phone: string | number | null): string => {
  const phoneStr = (phone ?? '').toString().replace(/[^\+0-9]/g, '');
  // Considering that phone control adds country phone code for blank phone.
  return phoneStr.length <= 5 ? '' : phoneStr;
};
